import {Client, Location} from './types';

export const EmptyClient: Client = {
  id: '',
  clId: undefined,
  clCname: '',
  clAdd1: '',
  clAdd2: '',
  clCity: '',
  clState: '',
  clZip: '',
  clContact: '',
  clPhone: '',
  clFax: '',
  clCphone: '',
  clRep: '',
  clSince: '',
  clType: '',
  clFamily: false,
  clCemet: false,
  clCremat: false,
  clMonu: false,
  clPreneed: false,
  clPet: false,
  clEvent: false,
  clCcc: false,
  clDalast: false,
  clDafirst: false,
  clCode: '',
  clCrcode: '',
  clCecode: '',
  clBranch: false,
  clArrcode: false,
  clRankgrp: '',
  clSentby: '',
  clLookup: '',
  clActive: false,
  clSpecial: false,
  clSupgrp: false,
  clArbal: undefined,
  clArdays: undefined,
  clThres: undefined,
  clCostper: undefined,
  clAdesc: '',
  clAmonths: undefined,
  clNet: undefined,
  clTrainer: '',
  clWebsite: '',
  clSname: '',
  clExclude: false,
  clCanada: false,
  clSoftwar: '',
  clRegion: undefined,
  clEsurvey: false,
  clGeneric: false,
  clTpib1l: undefined,
  clTpib1u: undefined,
  clTpib2l: undefined,
  clTpib2u: undefined,
  clTpib3l: undefined,
  clTpib3u: undefined,
  clScdate: null,
  clSadate: null,
  clCondate: null,
  clKodate: null,
  clSmsdate: null,
  clPcname: '',
  clPctitle: '',
  clPcphone: '',
  clPcemail: '',
  clPcadded: false,
  clBlname: '',
  clBltitle: '',
  clIaname: '',
  clIaemail: '',
  clIan2: '',
  clIae2: '',
  clPrname: '',
  clPsname: '',
  clPsn2: '',
  clDsname: '',
  clPrecoa: false,
  clSecarr: false,
  clComment: '',
  regionId: '',
  isElectronicFuneral: false,
  isElectronicCremation: false,
  isElectronicPreNeed: false,
  isprintsurvletr: false,
  issendemail: false,
  issendtext: false,
  isspanish: false,
  surveyNotifEmail1: '',
  surveyNotifEmail2: '',
  reportOverrides: [],
  arrangers: [],
  locations: [],
  groups: [],
};

export const EmptyLocation: Location = {
  id: '',
  clientId: '',
  regionId: '',
  loClient: undefined,
  loId: '',
  loName: '',
  loAdd1: '',
  loAdd2: '',
  loCity: '',
  loState: '',
  loZip: '',
  loContact: '',
  loPhone: '',
  loFax: '',
  loCell: '',
  loSince: '',
  loGroup: '',
  loDacode: '',
  loRegion: undefined,
  loSscode: '',
  loRptname: '',
  loBranch: '',
  loFuneral: false,
  loCremate: false,
  loCemeter: false,
  loMonu: false,
  loPre: false,
  loPetcrem: false,
  loEvent: false,
  loLookup: '',
  loInact: false,
  clientName: '',
  aliases: [],
};
